export const environment = {
  production: true,
  apiUrl: '',
  baseHref: '/',
  enableDebug: false,
  lang: 'en-GB',
  refreshPeriod: 5000,
  relativeDesktopApplicationLink: '',
  decimalPrecision: 2,
  aot: true,
  optimization: false,
  outputHashing: 'all',
  buildOptimizer: true,
};

